import * as React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import FirstStep from '../FirstStep/FirstStep';
import SecondStep from '../SecondStep.tsx/SecondStep';
import ThirdStep from '../ThirdStep/ThirdStep';
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

function SigninForm() {
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());

  const steps = ['Dados', 'Documentação', 'Finalizar'];
  const handleSteps = (step: number) => {
    switch (step) {
      case 0:
        return <FirstStep />
      case 1:
        return <SecondStep />
      case 2:
        return <ThirdStep />
      default:
        throw new Error('Unknown step')
    }
  }

  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  // const handleReset = () => {
  //   setActiveStep(0);
  // };

  return(

    <>
    <div className="absolute top-0">
      <button className="bg-white rounded-lg p-2 py-3 self-start m-10"
        onClick={(e) => {
          e.preventDefault();
          navigate("/");
        } }><ArrowBackIosIcon sx={{ marginLeft: '8px' }} /></button>
    </div>

    <div>
        <Box sx={{ width: '90%', m: 'auto' }}>
        {/* <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === steps.length ? (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>
            All steps completed - you&apos;re finished
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button onClick={handleReset}>Reset</Button>
          </Box>
        </React.Fragment>



      ) : (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Box sx={{ flex: '1 1 auto' }} />
            {isStepOptional(activeStep) && (
              <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                Skip
              </Button>
            )}
            <Button onClick={handleNext}>
              {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
            </Button>
          </Box> */}
         <Stepper activeStep={activeStep}>
            {steps.map((label) => {
              const stepProps: { completed?: boolean; } = {};
              const labelProps: {
                optional?: React.ReactNode;
              } = {};

              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>

          {activeStep === steps.length ? (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>

              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', pt: 2 }}>

              </Box>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="mt-[4em]">
                {handleSteps(activeStep)}
              </div>

              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', pt: 2 }}>
                <div className="flex flex-row items-center justify-center my-2 m-auto w-72">
                {isStepOptional(activeStep) && (
                  <button className="text-[--primary-color] font-semibold rounded-xl py-3 mr-4 w-36 hover:text-[--secondary-color] disabled:text-gray-300" color="inherit" onClick={handleSkip}>
                    Pular etapa
                  </button>
                )}
                  <button className="border bg-[color:--primary-color] text-white font-bold rounded-xl py-3 m-auto w-64 hover:bg-[color:--primary-color-hover] active:bg-[color:--primary-color-active]"
                  type="submit" onClick={activeStep === steps.length - 1 ? (e) => {
                    e.preventDefault();
                    navigate("/signin/signin-payment");
                  } : handleNext}>
                  {activeStep === steps.length - 1 ? 'Finalizar' : 'Continuar'}
                </button>
                </div>

                <button
                  className="text-[--primary-color] font-semibold rounded-xl py-3 mx-3 hover:text-[--secondary-color] disabled:text-gray-300"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                >
                  Voltar
                </button>

              </Box>
            </React.Fragment>
          )}
        </Box>
      </div></>
  )
}

export default SigninForm;